// extracted by mini-css-extract-plugin
module.exports = {"ImgWrapper":"AITravelPlannerBanner_ImgWrapper__iOf6O","Img":"AITravelPlannerBanner_Img__MTbby"};